<h1 class="mb-4 justify-self-center text-xl">Tank Transfers</h1>

<form
  #form="ngForm"
  novalidate
>
  <div class="text-md mb-2 grid grid-cols-4 gap-4 font-semibold">
    <div></div>
    <div class="text-center">From</div>
    <div class="text-center">To</div>
    <div class="text-center">Quantity</div>
  </div>

  <div data-ping-host>
    @for (transfer of stockStore.tankTransfers().transfers; track $index) {
      @let rowOptions = stockStore.vm().tankOptionsWithDisabled[$index];
      @let isRowRequired = stockStore.vm().isTransferRowRequired($index);
      <div class="mb-1 grid grid-cols-4 gap-1">
        <nsp-input-label
          [label]="`Transfer #${$index + 1}`"
          [required]="isRowRequired"
        ></nsp-input-label>

        <nsp-select-input
          [id]="`transfers-from-${$index}`"
          [name]="`transfers-from-${$index}`"
          [required]="isRowRequired"
          [options]="rowOptions.from"
          [showClear]="true"
          [value]="transfer.from.value"
          [ngModel]="transfer.from.value"
        />

        <nsp-select-input
          [id]="`transfers-to-${$index}`"
          [name]="`transfers-to-${$index}`"
          [required]="isRowRequired"
          [options]="rowOptions.to"
          [showClear]="true"
          [value]="transfer.to.value"
          [ngModel]="transfer.to.value"
        />
        <nsp-number-input
          [id]="`transfers-quantity-${$index}`"
          [name]="`transfers-quantity-${$index}`"
          [required]="isRowRequired"
          [min]="0"
          [unit]="units.metricTons"
          [value]="transfer.quantity.value"
          [ngModel]="transfer.quantity.value"
          [showClear]="true"
        />
      </div>
    }
  </div>
</form>
